import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ExternalLinkContext = createContext({});

const ExternalLinkProvider = props => {
  // NOTE: this provider used to compare document.domain against the host baked
  // into VITE_DEFAULT_AZURE_AUTH_REDIRECT_URI and hard-redirect on a mismatch,
  // pinning a build to exactly one hostname. That guard is deliberately gone:
  // the app is now served from several hosts off a SINGLE build (dev/demo
  // kwello.com, *.up.railway.app, localhost), and auth redirect URIs derive
  // from window.location.origin at runtime. Allowed hosts are enforced by the
  // identity providers (Auth0 / Azure AD callback allow-lists), not here.
  const [showExternalLinkDialog, setShowExternalLinkDialog] = useState(false);
  const [externalLinkData, setExternalLinkData] = useState({});

  const openExternalLink = useCallback(({ href, target }) => {
    setExternalLinkData({ href, target });
    setShowExternalLinkDialog(true);
  }, []);

  const toggleExternalLinkDialog = useCallback(() => {
    setShowExternalLinkDialog(!showExternalLinkDialog);
  }, [showExternalLinkDialog]);

  const value = useMemo(
    () => ({
      showExternalLinkDialog,
      externalLinkData,
      openExternalLink,
      toggleExternalLinkDialog,
    }),
    [showExternalLinkDialog, externalLinkData, openExternalLink, toggleExternalLinkDialog],
  );

  return <ExternalLinkContext.Provider value={value} {...props} />;
};

const useExternalLink = () => useContext(ExternalLinkContext);

export { ExternalLinkProvider, useExternalLink };
